module.exports = __webpack_public_path__ + "static/media/numero-icon.44ff251a.svg";